// import React from 'react';
// import WeTheme from '../theme/we-theme.js';
// import Container from '@material-ui/core/Container';

// export default function defaultLayout(props) {
//   return (
//     <React.Fragment>
//         <WeTheme>
//           <Box component="html">
//             <Container maxWidth="false" disableGutters={true}>
//               {props.children}
//             </Container>
//           </Box>
//         </WeTheme>
//     </React.Fragment>
//   );
// }

import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import Box from '@material-ui/core/Box';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createTheme } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import { Helmet } from 'react-helmet'

import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import "assets/scss/material-kit-react.scss?v=1.4.0"; //initialize stylesheets
import '@openfonts/montserrat_latin';
import '@openfonts/montserrat-alternates_latin';

import theme from "theme/we-theme";
import homeImage from "assets/img/home.png";

export default class DefaultLayout extends React.Component {
  render() {
    const { classes, ...rest } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />
        <ThemeProvider theme={ theme }>
          <Helmet>
            <meta charset="utf-8"/>
            <title>we the shareholders</title>
            <meta property="og:title" content="we the shareholders"/>
            <meta name="twitter:title" content="we the shareholders"/>
            <meta name="description" content="Join the Movement. Reclaim your shareholder voting rights and hold Corporate America accountable."/>
            <meta property="og:description" content="Join the Movement. Reclaim your shareholder voting rights and hold Corporate America accountable."/>
            <meta name="twitter:description" content="Join the Movement. Reclaim your shareholder voting rights and hold Corporate America accountable."/>
            <meta name="author" content="We the Shareholders PBC"/>
            <meta property="og:image" content={`https://wetheshareholders.com${homeImage}`}/>
            <meta name="twitter:image" content={`https://wetheshareholders.com${homeImage}`}/>
            <meta property="og:image:alt" content="A group of demonstrators exercising their civic rights. One is holding a loudspeaker and others have their fists raised up in the air."/>
            <meta name="twitter:image:alt" content="A group of demonstrators exercising their civic rights. One is holding a loudspeaker and others have their fists raised up in the air."/>
            <meta name="twitter:image:alt" content=""/>
            <meta property="og:locale" content="en_US"/>
            <meta property="og:type" content="website"/>
            <meta property="twitter:site" content="@wetheshldrs"/>
            <meta name="twitter:creator" content="@wetheshldrs"/>
            <meta property="og:site_name" content="we the shareholders"/>
            <meta name="twitter:card" content="summary_large_image"/>
          </Helmet>
          <Box component="div">
            <SnackbarProvider maxSnack={3}>
            <Header
              color="transparent"
              brand="we the shareholders"
              rightLinks={<HeaderLinks />}
              fixed
              changeColorOnScroll={{
                height: 100,
                color: "white",
                textShadow: "1px 1px 1px #7a7a7a",
              }}
              {...rest}
            />
              {this.props.children}
            </SnackbarProvider>
            </Box>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}